import React from "react";
import DeleteCell from "../tableLists/DeleteCell";
import DeleteButton from "../../buttons/DeleteButton";

function TableInputRow(props) {
    // Maps form input to table row. If the delete function is passed, it also adds a delete button to last column.
    return (
        <tr>
            {React.Children.map(props.children, (cell, index) => (
                <td key={index}>{cell}</td>
            ))}
            {props.delete && <DeleteCell delete={props.delete} ndx={props.ndx} index={props.index}/>}
        </tr>

    )
}

export default TableInputRow
